import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';

import { NbAuthOAuth2JWTToken, NbTokenService } from '@nebular/auth';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';

import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import { UserStore } from 'app/@core/stores/user.store';
import { User, UserData } from 'app/@core/interfaces/common/users';
import { Country, CountryData } from 'app/@core/interfaces/common/countries';
import { PHONE_PATTERN } from 'app/@auth/components';
import { UserInfoEnums } from './UserInfoEnums';

/**
 * Component for creation/edition of a Custom Food item
 */
@Component({
  selector: 'app-initial-user-info',
  templateUrl: './initial-user-info.component.html',
  styleUrls: ['./initial-user-info.component.scss'],
})
export class InitialUserInfoComponent
  extends BaseComponentCanDeactivate
  implements OnInit
{
  SuccessSavingUserInfo = $localize`:@@SuccessSavingUserInfo:User information saved!`;
  ProblemSavingUserInfo = $localize`:@@ProblemSavingUserInfo:Problem occurred when saving User information!`;

  UserInfoForm: FormGroup;

  UserInfoEnums = UserInfoEnums;

  ID = 0;
  currentUser: User;

  Countries: Observable<Country[]>;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.Canada,
  ];

  protected readonly unsubscribe$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private dialogRef: NbDialogRef<InitialUserInfoComponent>,
    private usersService: UserData,
    private toasterService: NbToastrService,
    private countriesService: CountryData,
    private userStore: UserStore,
    private tokenService: NbTokenService,
    dialogService: NbDialogService
  ) {
    super(dialogService);
  }

  ngOnInit(): void {
    this.InitUserForm();

    this.Countries = this.countriesService.list();

    const loadUser = this.usersService.getCurrentUser();

    loadUser.subscribe((user) => {
      this.currentUser = user;
      this.UserInfoForm.setValue({
        id: user.id ? user.id : '',
        firstName: user.firstName ? user.firstName : '',
        lastName: user.lastName ? user.lastName : '',
        businessName: user.businessName ? user.businessName : '',
        phoneNumber: user.phoneNumber ? user.phoneNumber : '',
        // Country: user.address && user.address.country ? user.address.country : '',
        //businessType: user.businessType ? user.businessType : '',
        //customersPerMonth: user.customersPerMonth ? user.customersPerMonth : '',
        address: {
          country:
            user.address && user.address.country ? user.address.country : '',
        },
      });
    });
  }

  get firstName() {
    return this.UserInfoForm.get('firstName');
  }
  get lastName() {
    return this.UserInfoForm.get('lastName');
  }
  get businessName() {
    return this.UserInfoForm.get('businessName');
  }
  get phoneNumber() {
    return this.UserInfoForm.get('phoneNumber');
  }
  get country() {
    return this.UserInfoForm.get('address.country');
  }
  get businessType() {
    return this.UserInfoForm.get('businessType');
  }
  get customersPerMonth() {
    return this.UserInfoForm.get('customersPerMonth');
  }

  /**
   * Initializes the form to create/edit a custom food item
   */
  InitUserForm() {
    this.UserInfoForm = this.fb.group({
      id: this.fb.control(''),
      firstName: this.fb.control('', [
        Validators.required,
        Validators.minLength(1),
      ]),
      lastName: this.fb.control('', [
        Validators.required,
        Validators.minLength(1),
      ]),
      businessName: this.fb.control('', [Validators.minLength(1)]),
      phoneNumber: this.fb.control('', [Validators.required]),
      // Country: this.fb.control('', [Validators.required, Validators.minLength(1)]),
      /* businessType: this.fb.control('', [
        Validators.required,
        Validators.minLength(1),
      ]),
    customersPerMonth: this.fb.control('', [
        Validators.required,
        Validators.minLength(1),
      ]),*/
      address: this.fb.group({
        country: this.fb.control('', [
          Validators.required,
          Validators.minLength(1),
        ]),
      }),
    });
    super.initForm(this.UserInfoForm);
  }

  convertToUser(value: any): User {
    const user: User = {
      ...value,
      phoneNumber: value.phoneNumber.internationalNumber,
    };
    return user;
  }

  /**
   * It converts the inputs of the form into the Custom Food type
   * and submit the form to save them
   */
  save() {
    const user: User = this.convertToUser(this.UserInfoForm.value);
    user.id = this.currentUser.id;

    this.usersService.updateCurrentInitial(user).subscribe(
      (result: any) => {
        this.tokenService.set(
          new NbAuthOAuth2JWTToken(result, 'email', new Date())
        );
        this.handleSuccessResponse();
        this.userStore.setUser(user);
        this.dialogRef.close(true);
      },
      (err) => {
        this.handleWrongResponse();
      }
    );
  }

  /**
   * Handler of Success event of submit
   */
  handleSuccessResponse() {
    super.resetDirty();

    this.toasterService.success('', this.SuccessSavingUserInfo);
  }

  /**
   * Handler of Fail event of submit
   */
  handleWrongResponse() {
    this.toasterService.danger('', this.ProblemSavingUserInfo);
  }
}
